(function () {
  "use strict";

  function initialize(scope) {
    var roots = [];

    if (scope.matches && scope.matches("[data-ftw-v2]")) {
      roots.push(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll("[data-ftw-v2]").forEach(function (root) {
        roots.push(root);
      });
    }

    roots.forEach(initializeOffer);
  }

  function initializeOffer(root) {
    if (root.dataset.ftwV2Ready === "true") {
      return;
    }

    root.dataset.ftwV2Ready = "true";

    function positiveInteger(value) {
      var result = Number(value);
      return Number.isFinite(result) && result > 0 ? result : null;
    }

    function attribute(name) {
      return root.getAttribute(name);
    }

    var config = {
      anchorDate: root.dataset.anchorDate || "",
      dateMode: root.dataset.dateMode === "arrival" ? "arrival" : "order",
      timeZone: root.dataset.timeZone || "America/Los_Angeles",
      cutoffWeekday: Number(root.dataset.cutoffWeekday || 3),
      orderWeekday: Number(root.dataset.orderWeekday || 1),
      transitMin: Number(root.dataset.transitMin || 5),
      transitMax: Number(root.dataset.transitMax || 7),
      launchEnabled: root.dataset.launchEnabled === "true",
      launchCutoff: root.dataset.launchCutoff || "",
      launchFirstOrder: root.dataset.launchFirstOrder || "",
      firstIssueOrderDate: root.dataset.firstIssueOrderDate || "2026-08-07",
      firstIssueShipDate: root.dataset.firstIssueShipDate || "2026-08-17",
      firstIssueNumber: Number(root.dataset.firstIssueNumber || 1),
      giftingEnabled: attribute("data-gifting-enabled") !== "false",
      price4: root.dataset.price4 || "$10",
      price12: root.dataset.price12 || "$30",
      pricePerIssue: root.dataset.pricePerIssue || "$2.50",
      variants: {
        4: positiveInteger(attribute("data-variant-4")),
        12: positiveInteger(attribute("data-variant-12"))
      },
      sellingPlans: {
        4: positiveInteger(attribute("data-selling-plan-4")),
        12: positiveInteger(attribute("data-selling-plan-12"))
      },
      giftVariants: {
        4: positiveInteger(attribute("data-gift-variant-4")),
        12: positiveInteger(attribute("data-gift-variant-12"))
      },
      giftSellingPlans: {
        4: positiveInteger(attribute("data-gift-selling-plan-4")),
        12: positiveInteger(attribute("data-gift-selling-plan-12"))
      }
    };

    function makeDate(year, month, day) {
      return new Date(Date.UTC(year, month - 1, day, 12));
    }

    function addDays(date, amount) {
      var result = new Date(date.getTime());
      result.setUTCDate(result.getUTCDate() + amount);
      return result;
    }

    function addBusinessDays(date, amount) {
      var result = new Date(date.getTime());
      var added = 0;

      while (added < amount) {
        result = addDays(result, 1);
        if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) {
          added += 1;
        }
      }

      return result;
    }

    function parseDate(value) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value || "")) {
        return null;
      }

      var parts = value.split("-").map(Number);
      return makeDate(parts[0], parts[1], parts[2]);
    }

    function todayInTimeZone(timeZone) {
      var parts = new Intl.DateTimeFormat("en-US", {
        timeZone: timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }).formatToParts(new Date());

      var values = {};

      parts.forEach(function (part) {
        if (part.type !== "literal") {
          values[part.type] = Number(part.value);
        }
      });

      return makeDate(values.year, values.month, values.day);
    }

    function nextWeekdayOnOrAfter(date, weekday) {
      return addDays(date, (weekday - date.getUTCDay() + 7) % 7);
    }

    function nextWeekdayAfter(date, weekday) {
      var difference = (weekday - date.getUTCDay() + 7) % 7;
      return addDays(date, difference === 0 ? 7 : difference);
    }

    function weeklyDates(firstDate, count) {
      var dates = [];
      var index;

      for (index = 0; index < count; index += 1) {
        dates.push(addDays(firstDate, index * 7));
      }

      return dates;
    }

    function arrivalRanges(orderDates) {
      return orderDates.map(function (date) {
        return {
          start: addBusinessDays(date, config.transitMin),
          end: addBusinessDays(date, config.transitMax)
        };
      });
    }

    function earliestArrivals(ranges) {
      return ranges.map(function (range) {
        return range.start;
      });
    }

    function formatFull(date) {
      return new Intl.DateTimeFormat("en-US", {
        timeZone: "UTC",
        weekday: "long",
        month: "long",
        day: "numeric"
      }).format(date);
    }

    function formatMonthDay(date) {
      return new Intl.DateTimeFormat("en-US", {
        timeZone: "UTC",
        month: "long",
        day: "numeric"
      }).format(date);
    }

    function formatWeekdayPlural(date) {
      return new Intl.DateTimeFormat("en-US", {
        timeZone: "UTC",
        weekday: "long"
      }).format(date) + "s";
    }

    function formatRange(start, end) {
      var sameMonth =
        start.getUTCFullYear() === end.getUTCFullYear() &&
        start.getUTCMonth() === end.getUTCMonth();

      if (sameMonth) {
        return formatMonthDay(start) + "–" + end.getUTCDate();
      }

      return formatMonthDay(start) + "–" + formatMonthDay(end);
    }

    function isoDate(date) {
      return [
        date.getUTCFullYear(),
        String(date.getUTCMonth() + 1).padStart(2, "0"),
        String(date.getUTCDate()).padStart(2, "0")
      ].join("-");
    }

    function daysBetween(start, end) {
      return Math.round((end.getTime() - start.getTime()) / 86400000);
    }

    function issueNumberForShipDate(shipDate) {
      var firstIssueShipDate = parseDate(config.firstIssueShipDate);

      if (!firstIssueShipDate || !shipDate) {
        return null;
      }

      var weeksSinceFirstIssue = Math.round(
        daysBetween(firstIssueShipDate, shipDate) / 7
      );

      return config.firstIssueNumber + weeksSinceFirstIssue;
    }

    function issueRangeCopy(shipDates) {
      if (!shipDates || !shipDates.length) {
        return "";
      }

      var firstIssue = issueNumberForShipDate(shipDates[0]);
      var lastIssue = issueNumberForShipDate(shipDates[shipDates.length - 1]);

      if (firstIssue === null || lastIssue === null) {
        return "";
      }

      if (firstIssue === lastIssue) {
        return "Issue " + firstIssue;
      }

      return "Issues " + firstIssue + "-" + lastIssue;
    }

    function compactDates(dates) {
      var groups = [];

      dates.forEach(function (date) {
        var key = date.getUTCFullYear() + "-" + date.getUTCMonth();
        var last = groups[groups.length - 1];

        if (!last || last.key !== key) {
          groups.push({
            key: key,
            month: new Intl.DateTimeFormat("en-US", {
              timeZone: "UTC",
              month: "long"
            }).format(date),
            days: [date.getUTCDate()]
          });
        } else {
          last.days.push(date.getUTCDate());
        }
      });

      return groups.map(function (group) {
        return group.month + " " + group.days.join(", ");
      }).join("; ");
    }

    function setText(selector, value) {
      root.querySelectorAll(selector).forEach(function (element) {
        element.textContent = value;
      });
    }

    var today = parseDate(config.anchorDate) || todayInTimeZone(config.timeZone);
    var launchCutoff = parseDate(config.launchCutoff);
    var launchFirstOrder = parseDate(config.launchFirstOrder);

    var launchIsBinding =
      config.launchEnabled &&
      launchCutoff &&
      launchFirstOrder &&
      launchCutoff.getTime() >= today.getTime() &&
      launchFirstOrder.getTime() >= today.getTime();

    var cutoffDate;
    var firstOrderDate;

    if (launchIsBinding) {
      cutoffDate = launchCutoff;
      firstOrderDate = launchFirstOrder;
    } else {
      cutoffDate = nextWeekdayOnOrAfter(today, config.cutoffWeekday);
      firstOrderDate = nextWeekdayAfter(cutoffDate, config.orderWeekday);
    }

    var orderDates4 = weeklyDates(firstOrderDate, 4);
    var orderDates12 = weeklyDates(firstOrderDate, 12);
    var arrivalRanges4 = arrivalRanges(orderDates4);
    var arrivalRanges12 = arrivalRanges(orderDates12);
    var renewal4 = addDays(firstOrderDate, 28);
    var renewal12 = addDays(firstOrderDate, 84);

    var urlParameters = new URLSearchParams(window.location.search);
    var giftParameter = (urlParameters.get("gift") || "").toLowerCase();
    var giftRequested =
      giftParameter === "1" ||
      giftParameter === "true" ||
      giftParameter === "yes";
    var requestedPlan = Number(urlParameters.get("plan"));
    var timeMachineParameter = (urlParameters.get("time_machine") || "").toLowerCase();
    var timeMachineRequested =
      timeMachineParameter === "1" ||
      timeMachineParameter === "true" ||
      timeMachineParameter === "yes";
    var requestedOrderDate = urlParameters.get("order_date") || "";

    var modal = root.querySelector("[data-ftw-v2-modal]");
    var modalDates = root.querySelector("[data-ftw-v2-modal-dates]");
    var modalDialog = modal ? modal.querySelector(".ftw-v2-modal__dialog") : null;
    var scheduleTimeline = root.querySelector("[data-ftw-v2-schedule-timeline]");
    var scheduleSummary = root.querySelector("[data-ftw-v2-schedule-summary]");
    var scheduleToggle = root.querySelector("[data-ftw-v2-schedule-toggle]");
    var timeMachineLink = root.querySelector("[data-ftw-v2-time-machine-toggle]");
    var timeMachinePanel = root.querySelector("[data-ftw-v2-time-machine]");
    var timeMachineDate = root.querySelector("[data-ftw-v2-time-machine-date]");
    var timeMachineStatus = root.querySelector("[data-ftw-v2-time-machine-status]");
    var paidButton = root.querySelector("[data-ftw-v2-paid-button]");
    var purchaseNote = root.querySelector("[data-ftw-v2-purchase-note]");
    var purchaseError = root.querySelector("[data-ftw-v2-purchase-error]");
    var giftWrapper = root.querySelector("[data-ftw-v2-gift-wrapper]");
    var giftToggle = root.querySelector("[data-ftw-v2-gift-toggle]");
    var giftFields = root.querySelector("[data-ftw-v2-gift-fields]");
    var giftEmail = root.querySelector("[data-ftw-v2-gift-email]");
    var giftMessage = root.querySelector("[data-ftw-v2-gift-message]");
    var datesBox = root.querySelector("[data-ftw-v2-dates-box]");
    var stamp = root.querySelector("[data-ftw-v2-stamp], .ftw-v2-stamp");
    var comparisonTable = root.querySelector(".ftw-v2-table");
    var freePlan = root.querySelector("#fresh-tank-free-plan");
    var paidPlan = root.querySelector("#fresh-tank-paid-plan");

    var activePlan = requestedPlan === 12 ? 12 : 4;
    var modalMode = "ship";
    var timeMachineActive = false;
    var timeMachineSchedule = null;
    var giftMode = Boolean(
      config.giftingEnabled &&
      giftToggle &&
      (giftRequested || giftToggle.checked)
    );
    var lastFocusedElement = null;

    var stampUserPlaced = false;
    var stampDragging = false;
    var stampPointerId = null;
    var stampDragX = 0;
    var stampDragY = 0;
    var stampStartDragX = 0;
    var stampStartDragY = 0;
    var stampPointerStartX = 0;
    var stampPointerStartY = 0;
    var stampStartRect = null;
    var stampBoundsRect = null;
    var stampStickTimer = null;

    if (giftToggle && giftRequested) {
      giftToggle.checked = true;
    }

    function getPlanData(plan) {
      return {
        orderDates: plan === 4 ? orderDates4 : orderDates12,
        arrivalRanges: plan === 4 ? arrivalRanges4 : arrivalRanges12,
        renewal: plan === 4 ? renewal4 : renewal12
      };
    }

    function normalScheduleForPlan(plan) {
      var data = getPlanData(plan);

      return {
        state: "ok",
        cutoff: cutoffDate,
        firstOrder: firstOrderDate,
        orderDates: data.orderDates,
        arrivalRanges: data.arrivalRanges,
        renewal: data.renewal,
        launchBinding: launchIsBinding
      };
    }

    function scheduleForOrderDate(orderDate, plan) {
      var firstIssueOrderDate = parseDate(config.firstIssueOrderDate);
      var firstIssueShipDate = parseDate(config.firstIssueShipDate);
      var selectedLaunchCutoff = parseDate(config.launchCutoff);
      var selectedFirstOrder;
      var selectedCutoff;
      var count = plan === 12 ? 12 : 4;
      var planningHorizon = orderDates12[orderDates12.length - 1];

      if (!orderDate) {
        return { state: "empty" };
      }

      if (firstIssueOrderDate && orderDate.getTime() < firstIssueOrderDate.getTime()) {
        return { state: "before" };
      }

      if (
        config.launchEnabled &&
        selectedLaunchCutoff &&
        firstIssueShipDate &&
        orderDate.getTime() <= selectedLaunchCutoff.getTime()
      ) {
        selectedCutoff = selectedLaunchCutoff;
        selectedFirstOrder = firstIssueShipDate;
      } else {
        selectedCutoff = nextWeekdayOnOrAfter(orderDate, config.cutoffWeekday);
        selectedFirstOrder = nextWeekdayAfter(selectedCutoff, config.orderWeekday);
      }

      if (
        planningHorizon &&
        selectedFirstOrder.getTime() > planningHorizon.getTime()
      ) {
        return { state: "future" };
      }

      var selectedOrderDates = weeklyDates(selectedFirstOrder, count);

      return {
        state: "ok",
        selectedOrderDate: orderDate,
        cutoff: selectedCutoff,
        firstOrder: selectedFirstOrder,
        orderDates: selectedOrderDates,
        arrivalRanges: arrivalRanges(selectedOrderDates),
        renewal: addDays(selectedFirstOrder, plan === 12 ? 84 : 28),
        launchBinding: Boolean(
          config.launchEnabled &&
          selectedLaunchCutoff &&
          orderDate.getTime() <= selectedLaunchCutoff.getTime()
        )
      };
    }

    function activeModalSchedule() {
      if (timeMachineActive) {
        return timeMachineSchedule || { state: "empty" };
      }

      return normalScheduleForPlan(activePlan);
    }

    function clearError() {
      if (!purchaseError) {
        return;
      }

      purchaseError.textContent = "";
      purchaseError.hidden = true;
    }

    function showError(message) {
      if (!purchaseError) {
        return;
      }

      purchaseError.textContent = message;
      purchaseError.hidden = false;
    }

    function renderPriceCopy() {
      var total = activePlan === 4 ? config.price4 : config.price12;

      setText(
        "[data-ftw-v2-period]",
        giftMode
          ? "Per issue, " + total + " paid once"
          : "Per issue, " + total + " billed every " + activePlan + " weeks"
      );
    }

    function renderDateLanguage() {
      if (config.dateMode === "arrival") {
        setText(
          "[data-ftw-v2-dates-label]",
          giftMode ? "Their earliest arrival dates" : "Earliest arrival dates"
        );
      } else {
        setText(
          "[data-ftw-v2-dates-label]",
          giftMode
            ? activePlan === 4
              ? "Their next four letters ship"
              : "Their next twelve letters ship"
            : activePlan === 4
              ? "Your next four letters ship"
              : "Your next twelve letters ship"
        );
      }

      setText(
        "[data-ftw-v2-modal-heading]",
        giftMode
          ? activePlan === 4
            ? "Their four weekly letters"
            : "Their twelve weekly letters"
          : activePlan === 4
            ? "Your four weekly letters"
            : "Your twelve weekly letters"
      );

      setText(
        "[data-ftw-v2-renewal-label]",
        giftMode ? "Optional renewal date" : "Next billing date"
      );
    }

    function renderPurchaseMode() {
      if (!config.giftingEnabled) {
        giftMode = false;
      }

      root.classList.toggle("is-gift-mode", giftMode);

      if (giftWrapper) {
        giftWrapper.hidden = !config.giftingEnabled;
      }

      if (giftToggle) {
        giftToggle.checked = giftMode;
        giftToggle.setAttribute("aria-expanded", giftMode ? "true" : "false");
      }

      if (giftFields) {
        giftFields.hidden = !giftMode;
      }

      if (giftEmail) {
        giftEmail.required = giftMode;
      }

      if (datesBox) {
        datesBox.hidden = false;
      }

      if (paidButton) {
        paidButton.textContent = giftMode
          ? "Gift " + activePlan + " weeks of letters"
          : "Subscribe for " + activePlan + " weeks";
      }

      if (purchaseNote) {
        var entitlementIssueRange = issueRangeCopy(
          getPlanData(activePlan).orderDates
        );

        purchaseNote.textContent = giftMode
          ? entitlementIssueRange
            ? "One-time gift. They'll get " + entitlementIssueRange + "."
            : "One-time gift. Continuing is optional."
          : entitlementIssueRange
            ? "Cancel anytime. You'll still get " + entitlementIssueRange + "."
            : "Cancel anytime. Letters you bought will arrive.";
      }

      renderPriceCopy();
      renderDateLanguage();
      clearError();
    }

    function syncGiftModeFromControl() {
      giftMode = Boolean(
        config.giftingEnabled &&
        giftToggle &&
        giftToggle.checked
      );

      if (paidButton) {
        paidButton.disabled = false;
        paidButton.removeAttribute("aria-busy");
      }

      renderPurchaseMode();
    }

    root.ftwV2SyncGiftState = syncGiftModeFromControl;

    function setScheduleVisibility(hasSchedule) {
      [scheduleTimeline, scheduleSummary, scheduleToggle, modalDates].forEach(function (element) {
        if (element) {
          element.hidden = !hasSchedule;
        }
      });

      if (timeMachineStatus) {
        timeMachineStatus.hidden = hasSchedule;
      }
    }

    function renderScheduleSummary(schedule) {
      if (!schedule || schedule.state !== "ok") {
        setScheduleVisibility(false);

        if (timeMachineStatus) {
          if (!schedule || schedule.state === "empty") {
            timeMachineStatus.textContent = "Choose an order date to use the time machine.";
          } else if (schedule.state === "before") {
            timeMachineStatus.textContent = "No fresh tanks here";
          } else if (schedule.state === "future") {
            timeMachineStatus.textContent = "Planning Fresh Tanks later. Check again next week.";
          }
        }

        return;
      }

      setScheduleVisibility(true);

      setText("[data-ftw-v2-cutoff]", formatFull(schedule.cutoff));
      setText("[data-ftw-v2-first-order]", formatFull(schedule.firstOrder));
      setText(
        "[data-ftw-v2-arrival]",
        formatRange(schedule.arrivalRanges[0].start, schedule.arrivalRanges[0].end)
      );
      setText("[data-ftw-v2-next-renewal]", formatFull(schedule.renewal));

      if (timeMachineActive && schedule.selectedOrderDate) {
        setText(
          "[data-ftw-v2-modal-intro]",
          "Order date " +
            formatMonthDay(schedule.selectedOrderDate) +
            " maps to the mailing cycle below."
        );
      } else if (schedule.launchBinding && launchCutoff && launchFirstOrder) {
        setText(
          "[data-ftw-v2-modal-intro]",
          "Orders placed through " +
            formatMonthDay(launchCutoff) +
            " begin shipping " +
            formatMonthDay(launchFirstOrder) +
            "."
        );
      } else {
        setText(
          "[data-ftw-v2-modal-intro]",
          "Subscribe before the cutoff to join this mailing cycle."
        );
      }
    }

    function renderModalDates() {
      var schedule = activeModalSchedule();

      if (!modalDates) {
        return;
      }

      modalDates.innerHTML = "";
      renderScheduleSummary(schedule);

      if (!schedule || schedule.state !== "ok") {
        return;
      }

      schedule.orderDates.forEach(function (orderDate, index) {
        var item = document.createElement("li");
        var dateMarkup;
        var issueNumber = issueNumberForShipDate(orderDate);
        var issueCopy = issueNumber !== null ? "Issue " + issueNumber : "Issue";

        if (modalMode === "arrival") {
          var range = schedule.arrivalRanges[index];
          dateMarkup =
            '<span class="ftw-v2-modal__date-value">' +
              formatRange(range.start, range.end) +
            "</span>";
        } else {
          dateMarkup =
            '<time class="ftw-v2-modal__date-value" datetime="' +
              isoDate(orderDate) +
            '">' +
              formatFull(orderDate) +
            "</time>";
        }

        item.innerHTML =
          '<div class="ftw-v2-modal__date-text">' +
            '<span class="ftw-v2-modal__letter-number">' +
              issueCopy +
            "</span>" +
            dateMarkup +
          "</div>" +
          '<span class="ftw-v2-modal__included">Included</span>';

        modalDates.appendChild(item);
      });
    }

    function renderTimeMachine() {
      if (!timeMachineActive) {
        timeMachineSchedule = null;
        renderModalDates();
        return;
      }

      var selectedDate = timeMachineDate
        ? parseDate(timeMachineDate.value)
        : null;

      timeMachineSchedule = scheduleForOrderDate(selectedDate, activePlan);
      renderModalDates();
    }

    function setTimeMachineActive(active, options) {
      var settings = options || {};
      timeMachineActive = Boolean(active);

      if (modalDialog) {
        modalDialog.classList.toggle("is-time-machine", timeMachineActive);
        modalDialog.classList.toggle(
          "is-time-machine-deep-linked",
          Boolean(timeMachineActive && settings.deepLinked)
        );
      }

      if (timeMachinePanel) {
        timeMachinePanel.hidden = !timeMachineActive;
      }

      if (timeMachineLink) {
        timeMachineLink.setAttribute(
          "aria-expanded",
          timeMachineActive ? "true" : "false"
        );
        timeMachineLink.classList.toggle(
          "is-deep-linked",
          Boolean(timeMachineActive && settings.deepLinked)
        );
      }

      if (timeMachineActive && timeMachineDate) {
        if (settings.orderDate && parseDate(settings.orderDate)) {
          timeMachineDate.value = settings.orderDate;
        } else if (!timeMachineDate.value) {
          timeMachineDate.value = isoDate(today);
        }
      }

      renderTimeMachine();

      if (timeMachineActive && settings.focus && timeMachineDate) {
        window.setTimeout(function () {
          timeMachineDate.scrollIntoView({ block: "center", behavior: "smooth" });
          timeMachineDate.focus();
        }, 80);
      }
    }

    function renderModalToggle() {
      root.querySelectorAll("[data-ftw-v2-modal-mode]").forEach(function (button) {
        var selected = button.dataset.ftwV2ModalMode === modalMode;
        button.classList.toggle("is-active", selected);
        button.setAttribute("aria-selected", selected ? "true" : "false");
      });

      renderModalDates();
    }

    function renderPlan(plan) {
      activePlan = plan;

      root.querySelectorAll("[data-ftw-v2-plan]").forEach(function (button) {
        var selected = Number(button.dataset.ftwV2Plan) === plan;
        button.classList.toggle("is-active", selected);
        button.setAttribute("aria-selected", selected ? "true" : "false");
      });

      var data = getPlanData(plan);
      var displayedDates =
        config.dateMode === "arrival"
          ? earliestArrivals(data.arrivalRanges)
          : data.orderDates;

      setText("[data-ftw-v2-price]", config.pricePerIssue);

      if (plan === 4) {
        setText(
          "[data-ftw-v2-dates-preview]",
          compactDates(displayedDates)
        );
      } else {
        setText(
          "[data-ftw-v2-dates-preview]",
          formatWeekdayPlural(displayedDates[0]) +
            ", " +
            formatMonthDay(displayedDates[0]) +
            "-" +
            formatMonthDay(displayedDates[displayedDates.length - 1])
        );
      }

      setText("[data-ftw-v2-modal-term]", plan + " weeks");

      renderPurchaseMode();

      if (timeMachineActive) {
        renderTimeMachine();
      } else {
        renderModalDates();
      }
    }

    async function parseResponse(response) {
      var body;

      try {
        body = await response.json();
      } catch (error) {
        body = null;
      }

      if (!response.ok) {
        throw new Error(
          body && (body.description || body.message)
            ? body.description || body.message
            : "The subscription could not be added to the cart."
        );
      }

      return body;
    }

    async function clearAndAdd(item) {
      var routeRoot =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : "/";

      var headers = {
        "Content-Type": "application/json",
        Accept: "application/json"
      };

      var clearResponse = await fetch(routeRoot + "cart/clear.js", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({})
      });

      await parseResponse(clearResponse);

      var addResponse = await fetch(routeRoot + "cart/add.js", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ items: [item] })
      });

      await parseResponse(addResponse);
      window.location.assign(routeRoot + "checkout");
    }

    async function handlePurchase() {
      clearError();
      var item;

      if (giftMode) {
        if (!config.giftSellingPlans[activePlan]) {
          showError("The gift selling plan is not configured.");
          return;
        }

        if (!giftEmail || !giftEmail.reportValidity()) {
          if (giftEmail) {
            giftEmail.focus();
          }
          return;
        }

        var recipientEmail = giftEmail.value.trim();

        if (!recipientEmail) {
          showError("Enter the gift recipient’s email.");
          giftEmail.focus();
          return;
        }

        item = {
          id: config.giftVariants[activePlan],
          quantity: 1,
          selling_plan: config.giftSellingPlans[activePlan],
          properties: {
            _prepaidGiftEmail: recipientEmail,
            _prepaidGiftMessage: giftMessage ? giftMessage.value.trim() : ""
          }
        };
      } else {
        item = {
          id: config.variants[activePlan],
          quantity: 1,
          selling_plan: config.sellingPlans[activePlan]
        };
      }

      if (!item.id || !item.selling_plan) {
        showError("The selected plan is missing its Shopify variant or Skio selling-plan ID.");
        return;
      }

      paidButton.disabled = true;
      paidButton.setAttribute("aria-busy", "true");
      paidButton.textContent = "Opening checkout…";

      try {
        await clearAndAdd(item);
      } catch (error) {
        showError(
          error && error.message
            ? error.message
            : "The subscription could not be added. Please try again."
        );

        paidButton.disabled = false;
        paidButton.removeAttribute("aria-busy");
        renderPurchaseMode();
      }
    }

    function openModal(trigger) {
      if (!modal) {
        return;
      }

      lastFocusedElement = trigger;
      modal.hidden = false;
      document.body.classList.add("ftw-v2-modal-is-open");

      window.setTimeout(function () {
        var closeButton = modal.querySelector(".ftw-v2-modal__close");
        if (closeButton) {
          closeButton.focus();
        }
      }, 0);
    }

    function closeModal() {
      if (!modal) {
        return;
      }

      modal.hidden = true;
      document.body.classList.remove("ftw-v2-modal-is-open");

      if (lastFocusedElement) {
        lastFocusedElement.focus();
      }
    }

    function clamp(value, minimum, maximum) {
      return Math.min(maximum, Math.max(minimum, value));
    }

    var scrollFrame = null;

    function smoothStep(start, end, value) {
      var normalized = clamp((value - start) / (end - start), 0, 1);
      return normalized * normalized * (3 - 2 * normalized);
    }

    function setStampDragPosition(x, y) {
      stampDragX = x;
      stampDragY = y;

      root.style.setProperty(
        "--ftw-v2-stamp-drag-x",
        Math.round(stampDragX) + "px"
      );

      root.style.setProperty(
        "--ftw-v2-stamp-drag-y",
        Math.round(stampDragY) + "px"
      );
    }

    function setStampPickupState(active) {
      root.style.setProperty(
        "--ftw-v2-stamp-pickup-z",
        active ? "42px" : "0px"
      );

      root.style.setProperty(
        "--ftw-v2-stamp-pickup-rotate-x",
        active ? "-8deg" : "0deg"
      );

      root.style.setProperty(
        "--ftw-v2-stamp-pickup-scale",
        active ? "1.04" : "1"
      );

      root.style.setProperty(
        "--ftw-v2-stamp-shadow-opacity",
        active ? "0.28" : "0.06"
      );
    }

    function flattenPlacedStamp() {
      root.style.setProperty("--ftw-v2-stamp-y", "0px");
      root.style.setProperty("--ftw-v2-stamp-rotate-x", "0deg");
      root.style.setProperty("--ftw-v2-stamp-scale", "1");
    }

    function stampBounds() {
      if (!paidPlan) {
        return null;
      }

      return (
        paidPlan.querySelector(".ftw-v2-letter-inner") ||
        paidPlan
      ).getBoundingClientRect();
    }

    function clampPlacedStamp() {
      if (!stamp || !stampUserPlaced || stampDragging) {
        return;
      }

      var bounds = stampBounds();
      if (!bounds) {
        return;
      }

      var rect = stamp.getBoundingClientRect();
      var inset = 8;
      var correctionX = 0;
      var correctionY = 0;

      if (rect.left < bounds.left + inset) {
        correctionX += bounds.left + inset - rect.left;
      }

      if (rect.right > bounds.right - inset) {
        correctionX -= rect.right - (bounds.right - inset);
      }

      if (rect.top < bounds.top + inset) {
        correctionY += bounds.top + inset - rect.top;
      }

      if (rect.bottom > bounds.bottom - inset) {
        correctionY -= rect.bottom - (bounds.bottom - inset);
      }

      if (correctionX || correctionY) {
        setStampDragPosition(
          stampDragX + correctionX,
          stampDragY + correctionY
        );
      }
    }

    function beginStampDrag(event) {
      if (!stamp || !paidPlan || event.button > 0) {
        return;
      }

      event.preventDefault();

      stampDragging = true;
      stampUserPlaced = true;
      stampPointerId = event.pointerId;
      stampStartDragX = stampDragX;
      stampStartDragY = stampDragY;
      stampPointerStartX = event.clientX;
      stampPointerStartY = event.clientY;
      stampStartRect = stamp.getBoundingClientRect();
      stampBoundsRect = stampBounds();

      if (stampStickTimer) {
        window.clearTimeout(stampStickTimer);
        stampStickTimer = null;
      }

      root.classList.remove("is-stamp-sticking");
      root.classList.add("is-stamp-dragging");

      setStampPickupState(true);

      if (stamp.setPointerCapture) {
        stamp.setPointerCapture(event.pointerId);
      }
    }

    function moveStamp(event) {
      if (
        !stampDragging ||
        event.pointerId !== stampPointerId ||
        !stampStartRect ||
        !stampBoundsRect
      ) {
        return;
      }

      event.preventDefault();

      var deltaX = event.clientX - stampPointerStartX;
      var deltaY = event.clientY - stampPointerStartY;
      var inset = 8;

      var minX =
        stampStartDragX +
        (stampBoundsRect.left + inset - stampStartRect.left);

      var maxX =
        stampStartDragX +
        (stampBoundsRect.right - inset - stampStartRect.right);

      var minY =
        stampStartDragY +
        (stampBoundsRect.top + inset - stampStartRect.top);

      var maxY =
        stampStartDragY +
        (stampBoundsRect.bottom - inset - stampStartRect.bottom);

      setStampDragPosition(
        clamp(stampStartDragX + deltaX, minX, maxX),
        clamp(stampStartDragY + deltaY, minY, maxY)
      );
    }

    function endStampDrag(event) {
      if (
        !stampDragging ||
        (event && event.pointerId !== stampPointerId)
      ) {
        return;
      }

      stampDragging = false;

      if (
        stamp &&
        stampPointerId !== null &&
        stamp.releasePointerCapture
      ) {
        try {
          stamp.releasePointerCapture(stampPointerId);
        } catch (error) {
          /* Pointer capture may already have been released. */
        }
      }

      stampPointerId = null;
      stampStartRect = null;
      stampBoundsRect = null;

      root.classList.remove("is-stamp-dragging");
      root.classList.add("is-stamp-sticking");

      flattenPlacedStamp();
      setStampPickupState(false);

      stampStickTimer = window.setTimeout(function () {
        root.classList.remove("is-stamp-sticking");
        stampStickTimer = null;
        clampPlacedStamp();
      }, 280);
    }

    function updateScrollEffects() {
      scrollFrame = null;

      var mobile = window.matchMedia("(max-width: 760px)").matches;
      var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      if (reducedMotion || !paidPlan) {
        root.style.setProperty("--ftw-v2-screen-off", "0");
        root.style.setProperty("--ftw-v2-cable-top", "0px");
        root.style.setProperty("--ftw-v2-cable-y", "0px");
        root.style.setProperty("--ftw-v2-letter-rotate-x", "0deg");
        root.classList.remove("is-cable-buried");
        root.style.setProperty("--ftw-v2-stamp-y", "0px");
        root.style.setProperty("--ftw-v2-stamp-rotate-x", "0deg");
        root.style.setProperty("--ftw-v2-stamp-scale", "1");
        root.style.setProperty("--ftw-v2-stamp-shadow-opacity", "0.04");
        return;
      }

      var rectangle = paidPlan.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var visibleTop = Math.max(0, rectangle.top);
      var visibleBottom = Math.min(viewportHeight, rectangle.bottom);
      var visibleHeight = Math.max(0, visibleBottom - visibleTop);
      var viewportCoverage = viewportHeight > 0
        ? clamp(visibleHeight / viewportHeight, 0, 1)
        : 0;

      /*
        The letter animation is shared by desktop and mobile:
          RECT3D rotX=-3deg rotY=0deg rotZ=0deg
          to
          RECT3D rotX=0deg rotY=0deg rotZ=0deg

        Only mobile gets the phone power-down and cable motion.
      */
      var letterProgress = smoothStep(0.02, 0.5, viewportCoverage);

      var stampProgress = 0;
      if (paidButton) {
        var buttonRectangle = paidButton.getBoundingClientRect();
        var buttonTravel = 140;
        var buttonEntry = clamp(
          (viewportHeight - buttonRectangle.top) / buttonTravel,
          0,
          1
        );
        stampProgress = smoothStep(0, 1, buttonEntry);
      }

      root.style.setProperty(
        "--ftw-v2-letter-rotate-x",
        (-3 * (1 - letterProgress)).toFixed(2) + "deg"
      );
      if (!stampUserPlaced) {
        root.style.setProperty(
          "--ftw-v2-stamp-y",
          Math.round((1 - stampProgress) * -38) + "px"
        );
        root.style.setProperty(
          "--ftw-v2-stamp-rotate-x",
          (-14 * (1 - stampProgress)).toFixed(2) + "deg"
        );
        root.style.setProperty(
          "--ftw-v2-stamp-scale",
          (1 + (1 - stampProgress) * 0.07).toFixed(3)
        );
        root.style.setProperty(
          "--ftw-v2-stamp-shadow-opacity",
          (0.04 + (1 - stampProgress) * 0.20).toFixed(3)
        );
      }

      if (!mobile) {
        root.style.setProperty("--ftw-v2-screen-off", "0");
        root.style.setProperty("--ftw-v2-cable-top", "0px");
        root.style.setProperty("--ftw-v2-cable-y", "0px");
        root.classList.remove("is-cable-buried");
        return;
      }

      if (comparisonTable && freePlan) {
        var tableRectangle = comparisonTable.getBoundingClientRect();
        var freeRectangle = freePlan.getBoundingClientRect();
        var pluggedTop = Math.round(freeRectangle.bottom - tableRectangle.top - 12);
        root.style.setProperty("--ftw-v2-cable-top", pluggedTop + "px");
      }

      var screenProgress = smoothStep(0, 0.5, viewportCoverage);
      var cableProgress = smoothStep(0, 0.6, viewportCoverage);

      root.style.setProperty(
        "--ftw-v2-screen-off",
        String(clamp(screenProgress * 1.06, 0, 1))
      );
      root.style.setProperty(
        "--ftw-v2-cable-y",
        Math.round(cableProgress * 132) + "px"
      );
      root.classList.toggle(
        "is-cable-buried",
        viewportCoverage >= 0.6
      );
    }

    function requestScrollEffects() {
      if (scrollFrame !== null) {
        return;
      }

      scrollFrame = window.requestAnimationFrame(updateScrollEffects);
    }

    if (stamp) {
      stamp.addEventListener("pointerdown", beginStampDrag);
      stamp.addEventListener("pointermove", moveStamp);
      stamp.addEventListener("pointerup", endStampDrag);
      stamp.addEventListener("pointercancel", endStampDrag);
      stamp.addEventListener("lostpointercapture", function (event) {
        if (stampDragging && event.pointerId === stampPointerId) {
          endStampDrag(event);
        }
      });
      stamp.addEventListener("dragstart", function (event) {
        event.preventDefault();
      });
    }

    if (giftToggle) {
      giftToggle.addEventListener("change", function () {
        giftMode = Boolean(config.giftingEnabled && giftToggle.checked);
        renderPurchaseMode();
      });
    }

    if (timeMachineLink) {
      timeMachineLink.addEventListener("click", function (event) {
        event.preventDefault();
        setTimeMachineActive(!timeMachineActive, {
          focus: !timeMachineActive
        });
      });
    }

    if (timeMachineDate) {
      timeMachineDate.addEventListener("input", renderTimeMachine);
      timeMachineDate.addEventListener("change", renderTimeMachine);
    }

    if (paidButton) {
      paidButton.addEventListener("click", handlePurchase);
    }

    root.querySelectorAll("[data-ftw-v2-plan]").forEach(function (button) {
      button.addEventListener("click", function () {
        renderPlan(Number(button.dataset.ftwV2Plan));
      });
    });

    root.querySelectorAll("[data-ftw-v2-modal-mode]").forEach(function (button) {
      button.addEventListener("click", function () {
        modalMode = button.dataset.ftwV2ModalMode;
        renderModalToggle();
      });
    });

    root.querySelectorAll("[data-ftw-v2-open-modal]").forEach(function (button) {
      button.addEventListener("click", function () {
        openModal(button);
      });
    });

    root.querySelectorAll("[data-ftw-v2-close-modal]").forEach(function (button) {
      button.addEventListener("click", closeModal);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal && !modal.hidden) {
        closeModal();
      }
    });

    window.addEventListener("scroll", requestScrollEffects, { passive: true });
    window.addEventListener("resize", function () {
      requestScrollEffects();
      window.setTimeout(clampPlacedStamp, 0);
    }, { passive: true });

    renderPlan(activePlan);
    renderModalToggle();
    requestScrollEffects();

    window.setTimeout(function () {
      syncGiftModeFromControl();
      requestScrollEffects();

      if (timeMachineRequested) {
        if (paidPlan) {
          paidPlan.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }

        openModal(timeMachineLink || paidPlan);
        setTimeMachineActive(true, {
          orderDate: requestedOrderDate,
          focus: true,
          deepLinked: true
        });
      } else if (
        giftRequested &&
        window.location.hash === "#fresh-tank-paid-plan" &&
        paidPlan
      ) {
        paidPlan.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }, 0);
  }

  function syncAllGiftStates() {
    document.querySelectorAll("[data-ftw-v2]").forEach(function (root) {
      if (typeof root.ftwV2SyncGiftState === "function") {
        root.ftwV2SyncGiftState();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  window.addEventListener("pageshow", function () {
    window.setTimeout(syncAllGiftStates, 0);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initialize(event.target);
  });
})();
